// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { ControlFilled, UsergroupAddOutlined, BookOutlined, BuildOutlined } from '@ant-design/icons';
import useAuthContext from 'context/useAuthContext';

// type
import { NavItemType } from 'layout/mantis/types/MenuType';
import { TagFilled } from '@ant-design/icons/lib/icons';
import useGlobalContext from 'context/useGlobalContext';

// icons
const icons = {
	controlFilled: ControlFilled,
	usergroupAddOutlined: UsergroupAddOutlined,
	bookOutlined: BookOutlined,
	buildOutlined: BuildOutlined,
	tagFilled: TagFilled
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function CourseMenuItems() {
	const { permissions, roles } = useAuthContext();
	const { activeCompany } = useGlobalContext();
	let items: NavItemType = {};

	if (permissions) {
		if (
			permissions.some((el: string) => {
				// el === 'My_Courses' ||
				return el === 'Manage_Courses'|| el === 'Base_Setting';
			})
		) {
			items = {
				id: 'group-course',
				title: 'Course',
				type: 'group',
				icon: icons.bookOutlined,
				children: []
			};

			if (
				permissions.some((el: string) => {
					return el === 'My_Courses';
				})
			) {
				items.children.push({
					id: 'core-course-list-my-courses',
					title: 'My Courses',
					type: 'item',
					url: '/app/course/list/my/courses',
					icon: icons.bookOutlined,
					breadcrumbs: true
				});
			}
			if (
				permissions.some((el: string) => {
					return el === 'Manage_Courses';
				})
			) {
				items.children.push({
					id: 'core-course-list-course',
					title: 'Courses',
					type: 'item',
					url: '/app/course/list/courses',
					icon: icons.bookOutlined,
					breadcrumbs: true
				});

				items.children.push({
					id: 'core-course-list-manage-course',
					title: 'Manage Courses',
					type: 'item',
					url: '/app/manage/course',
					icon: icons.buildOutlined,
					breadcrumbs: true
				});
			}

			if (activeCompany.value == null) {
				if (
					permissions.some((el: string) => {
						return el === 'Base_Setting';
					})
				) {
					let course_setting = {
						id: 'core-setting-course',
						title: 'Course Settings',
						type: 'collapse',
						icon: icons.bookOutlined,
						breadcrumbs: true,
						children: []
					};

					course_setting.children.push({
						id: 'core-setting-course-type',
						title: 'Course Type',
						type: 'item',
						url: '/app/settings/course/types',
						breadcrumbs: true
					});
					course_setting.children.push({
						id: 'core-setting-course-content-type',
						title: 'Content Type',
						type: 'item',
						url: '/app/settings/course/content/types',
						breadcrumbs: true
					});
					course_setting.children.push({
						id: 'core-setting-course-awarding-bodies',
						title: 'Awarding Bodies',
						type: 'item',
						url: '/app/settings/course/awarding/bodies',
						breadcrumbs: true
					});

					course_setting.children.push({
						id: 'core-setting-course-management-levels',
						title: 'Management Levels',
						type: 'item',
						url: '/app/settings/course/management/levels',
						breadcrumbs: true
					});

					course_setting.children.push({
						id: 'core-setting-course-delivery-options',
						title: 'Delivery Options',
						type: 'item',
						url: '/app/settings/course/delivery/options',
						breadcrumbs: true
					});
					course_setting.children.push({
						id: 'core-setting-course-delivery-patterns',
						title: 'Delivery Patterns',
						type: 'item',
						url: '/app/settings/course/delivery/patterns',
						breadcrumbs: true
					});

					items.children.push(course_setting);
				}
			}

			// if (permissions.some((el: string) => {
			//     return (el === 'Manage_Roles')
			// })) {
			//     items.children.push({
			//         id: 'core-hr-roles',
			//         title: 'Roles',
			//         type: 'item',
			//         url: '/app/hr/roles',
			//         icon: icons.controlFilled,
			//         breadcrumbs: false
			//     });
			// }
		}
	}

	return items;
}
